module.exports = __webpack_public_path__ + "img/funnel-fill.9257ba29.svg";